import { Env } from '@stencil/core';


const gtagValues = {
  dev: {
    gtagId: 'GTM-0000000',
  },
  beta: {
    gtagId: 'GTM-0000001',
  },
  green: {
    gtagId: 'GTM-0000001',
  },
  prod: {
    gtagId: 'GTM-5M2BPL6',
  },
};

const index = Env.environment ?? 'dev';

export const gtagValue = gtagValues[index];
const _gtagId = gtagValue.gtagId;
export default function () {
  initGoogleAnalytics();
}

function initGoogleAnalytics() {
  (function (w: any, d, s, l, i, n) {
    w[l] = w[l] || [];
    w[n] =
      w[n] ||
      function () {
        w[l].push(arguments);
      };
    w[n]('js', new Date());
    w[n]('config', _gtagId);
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j['async'] = true;
    j['src'] = 'https://www.googletagmanager.com/gtag/js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', _gtagId, 'gtag');
}
